module.exports = __webpack_public_path__ + "img/snack-confirmation.99eeb9f6.svg";